// helper.jsx

/**
 * Capitalizes the first character of a string.
 * @param {string} str - The string to capitalize.
 * @returns {string} - String with the first character in uppercase.
 */
export function capitalizeFirstChar(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}
